const FirstLoginTour = (props) => {

  if (localStorage.getItem("lastLogin") === "null") {

    return true;
  }
  else {

    return false;
  }

};

export default FirstLoginTour;